'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SaveSearchRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveSearchRemote = exports.SaveSearchRemote = {
    fetchSavedSearches: function fetchSavedSearches(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>savedsearch/searches' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSavedSearchItems: function fetchSavedSearchItems(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>savedsearch/items' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postDeleteSavedSearch: function postDeleteSavedSearch(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            savedSearchId = _ref3.savedSearchId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                apiPath: 'deletesavedsearch',
                authToken: authToken,
                deployment: deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false
            });
            request.send({ savedSearchId: savedSearchId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postIsSavedSearch: function postIsSavedSearch(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment,
            searchParams = _ref4.searchParams;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                apiPath: 'getsearchsaved',
                authToken: authToken,
                deployment: deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false
            });
            request.send({ facets: searchParams });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSaveSearch: function postSaveSearch(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment,
            searchParams = _ref5.searchParams,
            sendAlert = _ref5.sendAlert;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                apiPath: 'savesearch',
                authToken: authToken,
                deployment: deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false
            });
            request.send({ facets: searchParams, sendAlert: sendAlert });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSubscribeToSavedSearch: function postSubscribeToSavedSearch(_ref6) {
        var authToken = _ref6.authToken,
            deployment = _ref6.deployment,
            savedSearchId = _ref6.savedSearchId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                apiPath: 'subscribesavedsearch',
                authToken: authToken,
                deployment: deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false
            });
            request.send({ savedSearchId: savedSearchId, sendAlert: true });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnsubscribeFromSavedSearch: function postUnsubscribeFromSavedSearch(_ref7) {
        var authToken = _ref7.authToken,
            deployment = _ref7.deployment,
            savedSearchId = _ref7.savedSearchId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({
                apiPath: 'subscribesavedsearch',
                authToken: authToken,
                deployment: deployment,
                path: '<SAVED-SEARCH-API>',
                useCacheKey: false
            });
            request.send({ savedSearchId: savedSearchId, sendAlert: false });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/saveSearch.js
// module id = 6Sk3
// module chunks = 60